import Table from '@shared/components/tables';
import { html, nothing } from '@shared/utils/rendering/html';
import { useEffect } from 'preact/hooks';

import { useApiKeysContext } from './context/api-keys.context';

const ApiKeysTable = ({ remoteSystemId }) => {
    const { tableData, config, setActiveSystem } = useApiKeysContext();

    useEffect(() => {
        setActiveSystem(remoteSystemId);
    }, [remoteSystemId]);

    return config ? html`<${Table} config=${config} data=${tableData} />` : nothing;
};

export default ApiKeysTable;
